// extracted by mini-css-extract-plugin
export default {"modalTitle":"ATtdjaeDd5juQ1JA16Zaa"};